import type { CreatePaymentIntentRequest, UpdatePaymentIntentRequest } from './types';

export const PAYMENT_QUERY_KEYS = {
  createPaymentIntent: (params: CreatePaymentIntentRequest) => ['payment', 'create-payment-intent', params] as const,
  updatePaymentIntent: (params: UpdatePaymentIntentRequest) => ['payment', 'update-payment-intent', params] as const,
} as const;
